'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.ConsumesFieldsetContext = exports.Provider = exports.Consumer = exports.defaultValues = exports.types = undefined;

var _react = require('react');

var _reactContext = require('../vendor/reactContext');

var _reactContext2 = _interopRequireDefault(_reactContext);

var _InputConstants = require('../input/InputConstants');

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = {
  disabled: _react.PropTypes.bool,
  size: _react.PropTypes.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS))
};

var defaultValues = exports.defaultValues = {
  disabled: false,
  size: 'default'
};

var _createContext = (0, _reactContext2.default)(defaultValues),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Consumer = Consumer;
exports.Provider = Provider;
var ConsumesFieldsetContext = exports.ConsumesFieldsetContext = (0, _consumerDecoratorFactory2.default)('fieldset', Consumer);

var propType = exports.propType = _react.PropTypes.shape(types);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/context/FieldsetContext.js
// module id = 311
// module chunks = 0